const outputDoc = {
  title: 'Testament',
  from: 'de',
  born: ' né le ',
  civilStatus: {
    single: 'Célibataire',
    married: 'Marié',
    widowed: 'Veuf',
    divorced: 'Divorcé',
    registered_partnership: 'Partenariat enregistré',
  },
  civil_status: 'État civil : {{civil_status}}',
  address: 'Adresse : {{address}}',
  declare: 'Je, {{first_name}} {{last_name}}, déclare ce qui suit :  ',

  paragraph1: "Je révoque tous les testaments que j'ai rédigés auparavant.",

  paragraph2:
    'Les dettes en cours et les frais de décès doivent être payés par la succession.',

  paragraph3: '{{civil_status}}',

  receivesNothing: 'ne reçoit rien.',

  and: 'et',

  p4MarriedSpouse: {
    marriedStatus: {
      male: 'Mon épouse',
      female: 'Mon époux',
    },
    livingPartnershipStatus: {
      male: 'Ma partenaire enregistrée',
      female: 'Mon partenaire enregistré',
    },
    partnerStatus: {
      male: 'Ma partenaire',
      female: 'Mon partenaire',
    },
    born: ', né le {{birthday}}, ',
    receivesAsHeir:
      'reçoit comme héritière la totalité de la quote-part disponible.',
  },

  marriedSpouseChildren: {
    biologicalChildren: {
      oneChild: {
        main: 'Mon enfant biologique et légalement reconnu ',
        born: ', né le {{birthday}}, ',
        receive: 'reçoit sa part légale de ma succession.',
      },
      multipleChildren: {
        main: 'Mes enfants biologiques et légalement reconnus ',
        born: ', né le {{birthday}}, ',
        receive: 'reçoivent chacun leur part légale de ma succession.',
      },
    },
  },

  marriedSpouseUsufruct: {
    marriedStatus: {
      male: 'À mon épouse',
      female: 'À mon époux',
    },
    livingPartnershipStatus: {
      male: 'À ma partenaire enregistrée',
      female: 'À mon partenaire enregistré',
    },
    usufructRights:
      "j'accorde en outre l'usufruit viager sur la part légale de mes enfants.",
  },

  p4UnmarriedPartner: {
    receives: 'reçoit la totalité de la part librement disponible.',
    receivesProperty: 'reçoit notamment aussi',
    theProperty: 'le bien immobilier',
    atTheAddress: "à l'adresse",
    assignedToProperty: 'attribué en propriété.',
    born: ', né le {{birthday}}, ',
    genderStatus: {
      male: 'Ma partenaire de vie',
      female: 'Mon partenaire de vie',
      male1: 'ma partenaire de vie',
      female1: 'mon partenaire de vie',
      registeredPartnerMale: 'Ma partenaire enregistrée',
      registeredPartnerFemale: 'Mon partenaire enregistré',
    },
  },

  p5UnmarriedPartnerWithChildren: {
    commonPartnership: {
      oneChild: {
        main: 'Notre enfant commun, ',
        born: ', né le {{birthday}}, ',
        receive: 'ou ses descendants reçoivent la part légale.',
      },
      multipleChildren: {
        main: 'Nos enfants communs, ',
        born: ', né le {{birthday}}, ',
        receive: 'ou tous leurs descendants reçoivent chacun la part légale.',
      },
      and: 'et',
    },
    otherPartnership: {
      oneChild: {
        main: 'Mon enfant non commun, ',
        born: ', né le {{birthday}}, ',
        receive: 'ou ses descendants reçoivent la part légale.',
      },
      multipleChildren: {
        main: 'Mes enfants non communs, ',
        born: ', né le {{birthday}}, ',
        receive:
          'ou tous leurs descendants reçoivent chacun à parts égales la part légale.',
      },
    },
    noPartnership: {
      oneChild: {
        main: 'Mon enfant, ',
        born: ', né le {{birthday}}, ',
        receive: ' ou ses descendants reçoivent la part légale.',
      },
      multipleChildren: {
        main: 'Mes enfants, ',
        born: ', né le {{birthday}}, ',
        receive: ' ou tous leurs descendants reçoivent chacun la part légale.',
      },
    },
    deathCase:
      'Si je décède en même temps que {{partner}}, alors {{childrenCase}}',
    born: ', né le {{birthday}}, ',
    childrenCase: {
      oneChild: {
        fromCommonMarriage: 'notre enfant commun reçoit, ',
        fromOtherMarriage: 'notre enfant non commun reçoit, ',
        fromUnknownMarriage: 'mon enfant reçoit,',
      },
      onesDescendants: 'ou ses descendants tous les actifs.',
      multipleChildren: {
        fromCommonMarriage: 'nos enfants communs reçoivent, ',
        fromOtherMarriage: 'nos enfants non communs reçoivent, ',
        fromUnknownMarriage: 'mes enfants reçoivent, ',
      },
      allDescendants: 'ou tous leurs descendants chacun tous les actifs.',
    },
  },

  p4Child: {
    biologicalChildren: {
      oneChild: {
        main: "J'institue mon enfant ",
        born: ', né le {{birthday}}, ',
        receive:
          "comme héritier de l'intégralité de ma succession. Il reçoit l'intégralité de ma succession.",
      },
      multipleChildren: {
        main: "J'institue mes enfants ",
        born: ', nés le {{birthday}}, ',
        receive:
          "à parts égales comme héritiers de l'intégralité de ma succession. Ils reçoivent chacun la moitié de ma succession.",
      },
    },
    partnerCase: {
      male: 'Mon épouse',
      female: 'Mon époux',
      born: ', né le {{birthday}}, ',
      receivesNothing: 'ne recevra aucune attribution de ma succession.',
      receivesCompulsoryPortion: 'reçoit sa part légale de ma succession.',
    },
  },

  unmarriedChildrenChoice: {
    biologicalChildren: {
      oneChild: {
        main: "J'institue mon enfant ",
        born: ', né le {{birthday}}, ',
        receive:
          "comme héritier de l'intégralité de ma succession. Il reçoit l'intégralité de ma succession.",
      },
      multipleChildren: {
        main: "J'institue mes enfants ",
        born: ', nés le {{birthday}}, ',
        receive:
          "à parts égales comme héritiers de l'intégralité de ma succession. Ils reçoivent chacun la moitié de ma succession.",
      },
    },
  },

  unmarriedPartnerCase: {
    male: 'Ma partenaire de vie',
    female: 'Mon partenaire de vie',
    born: ', né le {{birthday}}, ',
    receivesNothing: 'ne doit recevoir aucune attribution de ma succession.',
  },

  unmarriedPartnerDeathCase: {
    male: "Si je décède en même temps que ma partenaire de vie ou qu'elle ne survit pas à l'événement successoral, alors reçoit",
    female:
      "Si je décède en même temps que mon partenaire de vie ou qu'il ne survit pas à l'événement successoral, alors reçoit",
    multipleChildren: 'mon enfant, ',
    oneChild: 'mon enfant, ',
    born: ', né le {{birthday}}, ',
    descendants: 'ou ses descendants',
    multipleDescendants: 'ou leurs descendants',
    inheritAll:
      "toute la succession à parts égales avec d'autres héritiers (le cas échéant) ou seul si aucun autre héritier légal n'existe.",
    and: 'ainsi que',
  },

  unmarriedInstitutionChoice: {
    biologicalChildren: {
      oneChild: {
        main: 'Mon enfant biologique et légalement reconnu, ',
        born: ', né le {{birthday}}, ',
        receive: 'reçoit sa part légale de ma succession.',
      },
      multipleChildren: {
        main: 'Mes enfants biologiques et légalement reconnus, ',
        born: ', né le {{birthday}}, ',
        receive: 'reçoivent chacun leur part légale de ma succession.',
      },
    },
  },

  p4Institution: {
    oneInstitution: {
      main: "L'institution",
      receives: 'reçoit',
    },
    multipleInstitutions: {
      main: 'Les institutions',
      receives: 'reçoivent',
    },
    finals:
      ' chacun à parts égales tous les actifs dans le cadre de la part librement disponible. ',
    final: ' tous les actifs dans le cadre de la part librement disponible. ',
    partnerReceives: 'reçoit sa part légale de ma succession.',
    born: ', né le {{birthday}}, ',
    and: ' et ',
  },

  p5MarriedSpouse: {
    marriedStatus: {
      male: 'Mon épouse',
      female: 'Mon époux',
    },
    livingPartnershipStatus: {
      male: 'Ma partenaire enregistrée',
      female: 'Mon partenaire enregistré',
    },
    particularReceives: {
      marriedStatus:
        "Mon épouse doit recevoir le bien immobilier à {{address}} en pleine propriété dans le cadre de la quote disponible. Si la quote disponible ne suffit pas à cet effet, l'attribution doit être effectuée avec imputation sur sa part d'héritage.",
      livingPartnershipStatus:
        "Ma partenaire enregistrée doit recevoir le bien immobilier à {{address}} en pleine propriété dans le cadre de la quote disponible. Si la quote disponible ne suffit pas à cet effet, l'attribution doit être effectuée avec imputation sur sa part d'héritage.",
    },
    theProperty: 'le bien immobilier',
    atTheAddress: "à l'adresse",
    assignedToProperty: 'attribué en propriété.',
  },

  spouseSimultaneousDeathClause:
    "Si {{partnerTerminology}} {{partnerFullNameAndBirthday}} décède simultanément avec moi ou ne survit pas à l'événement de succession, le quota disponible de ma succession revient à mes deux enfants {{childrenNames}} à parts égales.",

  p5Institution: {
    commonMarriage: {
      oneChild: {
        main: 'Notre enfant commun, ',
        born: ' né le {{birthday}}, ',
        receive: 'ou ses descendants reçoivent la part légale.',
      },
      multipleChildren: {
        main: 'Nos enfants communs, ',
        born: ' né le {{birthday}}, ',
        receive: 'ou tous leurs descendants reçoivent chacun la part légale.',
      },
      and: 'et',
    },
    otherMarriage: {
      oneChild: {
        main: 'Mon enfant non commun, ',
        born: ' né le {{birthday}}, ',
        receive: 'ou ses descendants reçoivent la part légale.',
      },
      multipleChildren: {
        main: 'Mes enfants non communs, ',
        born: ' né le {{birthday}}, ',
        receive: 'ou tous leurs descendants reçoivent chacun la part légale.',
      },
      and: 'et',
    },
  },

  p6MarriedSpouse: {
    oneChild: {
      commonMarriage: 'Notre enfant commun, ',
      otherMarriage: 'Mon enfant non commun, ',
      born: ', né le {{birthday}}, ',
      receives: 'ou ses descendants reçoivent ',
    },
    multipleChildren: {
      commonMarriage: 'Nos enfants communs, ',
      otherMarriage: 'Mes enfants non communs, ',
      born: ', né le {{birthday}}, ',
      receives: 'ou tous leurs descendants reçoivent chacun',
    },
    final:
      "la part légale, grevée cependant de l'usufruit mentionné au premier paragraphe. ",
  },

  willExecutor:
    "En tant qu'exécuteur testamentaire pour l'ensemble de ma succession, je désigne {{executor1}}. En tant qu'exécuteur testamentaire de remplacement, je désigne {{executor2}}.",

  forFollowing: {
    main: "Pour les actifs suivants, une disposition différente s'applique :",
    asset: '{{asset}}, {{address}} va à : {{benefiter}}. ',
    devisionProvision:
      'Ceci est une disposition de partage en faveur de {{benefiter}}, pas un avantage supplémentaire.',
  },
  optionalUsufruct: {
    marriedMale: 'Ma femme',
    marriedFemale: 'Mon mari',
    partnerMale: 'Ma partenaire enregistrée',
    partnerFemale: 'Mon partenaire enregistré',
    receives: " reçoit le droit d'usufruit viager",
    propertyPart: ' sur ma propriété à {{address}}',
    andOr: ' et/ou',
    estatePart:
      ' sur des parties de ma succession, dans la mesure où cela est compatible avec les droits des héritiers légaux ou désignés.',
  },
};

export default outputDoc;
